import React, { useEffect, useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap-v5";
import { MdEdit, MdOutlineDeleteForever } from "react-icons/md";
import { DutyAndTaxService } from "../../Services/DutyAndTaxService";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Loader from "../../Components/Loader";
import ReactPaginate from "react-paginate";
import CheckAccess from "../../Function/CheckAccess";
let currentPage1 = 1;

export const DutyAndTaxList = () => {
  const [state, setState] = useState([]);
  const [deleteModal, setDeleteModal] = useState({ modal: false, id: null });
  const [loader, setLoader] = useState(true);
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  const [currentPage, setCurrentPage] = useState(currentPage1);
  const history = useHistory();

  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  const getDetail = async () => {
    setLoader(true);
    let param = {};
    param = { page: currentPage, limit: pagination.limit };
    await DutyAndTaxService.getDutyAndTaxList(param).then((res) => {
      if (res.status) {
        let finalData = res.data.reduce((acc, curr) => {
          let existingCountry = acc.find(
            (item) => item.country === curr.country
          );
          if (existingCountry) {
            existingCountry.data.push(curr);
          } else {
            acc.push({
              country: curr.country,
              data: [curr],
            });
          }
          return acc;
        }, []);
        // console.log(finalData,'finalData')
        setState(finalData);
        setPagination({ ...pagination, ...res.pagination });
        setLoader(false);
      }
    });
  };

  const handleDelete = async () => {
    const obj = { id: deleteModal.id };
    await DutyAndTaxService.deleteDutyAndTax(obj).then((res) => {
      setLoader(true);
      if (res.status) {
        setLoader(false);
        getDetail();
        toast.success(res.message);
        setDeleteModal({ modal: false, id: null });
      } else {
        setLoader(false);
        toast.error(res.message);
      }
    });
  };

  useEffect(() => {
    getDetail();
  }, [currentPage]);

  const onPageChangeEvent = (e) => {
    currentPage1 = e.selected + 1
    setLoader(true);
    setCurrentPage(e.selected + 1);
  };

  return (
    <div style={{ width: "75%" }}>
      <div className="card">
        <div className="card-body">
          <div className="text-end mb-3">
            {(CheckAccess(7,"add") || user_type === "SUPERADMIN") && (
              <Button
                type="button"
                className="btn btn-primary"
                onClick={() => history.push("/add-duty-and-tax")}
              >
                Add Duty and Tax
              </Button>
            )}
          </div>
          <div className="table-responsive table-bordered">
            <table className="table table-striped table-nowrap mb-0">
              <thead className="table-light">
                <tr>
                  <th>S No.</th>
                  <th>Country</th>
                  <th>Description</th>
                  <th>Duty %</th>
                  <th>Tax %</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan={5} className="text-center">
                      <Spinner animation="border" />
                    </td>
                  </tr>
                ) : state && state.length > 0 ? (
                  state?.map((item, key) => (
                    <tr key={key}>
                      {/* <td className="text-body fw-bold">{key + 1}</td> */}
                      <td className="text-body fw-bold">
                          {(currentPage - 1) * pagination.limit +
                            (key + 1)}
                        </td>
                      <td className="text-body align-top">{item?.country}</td>
                      <td className="text-body">
                        {item.data.map((itm) => (
                          <div style={{ marginBottom: "10px" }}>
                            {itm?.description}{" "}
                          </div>
                        ))}
                      </td>
                      <td className="text-body">
                        {item.data.map((itm) => (
                          <div style={{ marginBottom: "10px" }}>
                            {itm?.duty}{" "}
                          </div>
                        ))}
                      </td>
                      <td className="text-body">
                        {item.data.map((itm) => (
                          <div style={{ marginBottom: "10px" }}>
                            {itm?.tax}{" "}
                          </div>
                        ))}
                      </td>
                      <td className="text-body">
                        {item.data.map((itm) => (
                          <div style={{ marginBottom: "5px" }}>
                            {(CheckAccess(7,"edit") ||
                              user_type === "SUPERADMIN") && (
                              <MdEdit
                                className="pointer"
                                onClick={() =>
                                  history.push(
                                    "/edit-duty-and-tax?id=" + item._id,
                                    item
                                  )
                                }
                                style={{
                                  fontSize: "22px",
                                  color: "rgb(3, 35, 254)",
                                }}
                              />
                            )}

                            {(CheckAccess(7,"delete") ||
                              user_type === "SUPERADMIN") && (
                              <MdOutlineDeleteForever
                                className="pointer"
                                onClick={() =>
                                  setDeleteModal({ modal: true, id: item._id })
                                }
                                style={{ fontSize: "22px", color: "red" }}
                              />
                            )}
                          </div>
                        ))}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      Data Not Available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

              {state &&
                state.length > 0 &&
                pagination.totalRecord > pagination.limit && (
                  <ReactPaginate
                    previousLabel={
                      <img
                        src="assets/images/prev.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    forcePage={currentPage - 1}
                    nextLabel={
                      <img
                        src="assets/images/next.svg"
                        height={15}
                        alt="not found"
                      />
                    }
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(
                      pagination.totalRecord / pagination.limit
                    )}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={(e) => onPageChangeEvent(e)}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                  />
                )}
              <Loader isShow={loader} />
          </div>

          {/* {/ Delete Modal /} */}
          <Modal
            show={deleteModal.modal}
            onHide={() => setDeleteModal({ modal: false, id: null })}
            animation={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>Delete duty and taxes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h6>Are you sure want to delete duty and taxes</h6>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="success"
                onClick={() => setDeleteModal({ modal: false, id: null })}
              >
                Close
              </Button>
              <Button variant="danger" onClick={handleDelete}>
                {(loader && <Spinner animation="grow" size="sm" />) || "Delete"}
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
};
